<template>
    <!-- Overlay -->
    <v-dialog v-model="overlay" overlay-opacity="0.66" max-width="650px" @click:outside="closeAction"  >
        
      <HLOverlayCloseButton @close="closeAction"/>
      <LanguageSelector style="margin-top: -70px;margin-left:20px;"/>
      <div class="white px-10 pb-5 pt-7 ma-0 body-1 text-center mt-n10" >
        <div class="m-auto"><img src="/img/logo_GlobalSocial.jpeg" height="150"/></div>
        <p class="py-4">{{$t('landingpage_text')}}<br>{{$t('welcome_text')}}</p>
        <p class=""></p>
        <v-row class="pb-6" align="justify">
          <v-col cols="12" sm="4" align="center"><img src="/img/drawings/1.jpg" width="170px"/></v-col>
          <v-col cols="12" sm="4" align="center"><img src="/img/drawings/2.jpg" width="170px"/></v-col>
          <v-col cols="12" sm="4" align="center"><img src="/img/drawings/3.jpg" width="170px"/></v-col>
        </v-row>
        <v-btn class="ma-md-2 my-2 white--text" block depressed  :color="theme.hinterlandOrange" @click="closeAction" tile >{{$t('welcome_okay')}}</v-btn>
      </div>

    </v-dialog>
</template>

<script>
  import CONFIG from '@/constants/config.js';
  import {layoutMixin} from '@/utils/layout-mixin'
  import HLOverlayCloseButton from '@/components/ui/HLOverlayCloseButton.vue'
  import LanguageSelector from "@/components/ui/LanguageSelector"
  
  export default {
    mixins: [layoutMixin],
    components:{
      HLOverlayCloseButton,
      LanguageSelector
    },
    props:{
      value:{
        type:Boolean,
        default:false
      }
    },
    watch:{
      /* Init data on creation and on update */
      value: {
        handler(val) {
          this.overlay=val;
        },
        immediate: true
      },
    },
    computed:{
      contactFormTypeBookingRequest(){
        return CONFIG.MESSAGE_TYPE_BOOKING_REQUEST
      },

    },
    data: () => ({
      overlay: false,
    }),
    methods:{
      closeAction(){
        this.overlay=false;
        this.$emit('input',this.overlay);
      },
      closeDelayedAction(){
        setTimeout(()=>{
          this.closeAction();
        },1000);
      }
    }
  }
</script>

<style>
.acco_carousel_img_slider .v-window__prev,.acco_carousel_img_slider .v-window__next{
  background: none!important;
}
.acco_carousel_img_slider .window__next.v-btn.v-btn__content.v-icon{
  font-size:100px!important;
}
</style>
